var _desc, _rect, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 696,
    height: 696,
    viewBox: "0 0 696 696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 696,
    height: 696,
    fill: "#ffffff",
    cx: 0,
    cy: 0
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "p",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    r: 12,
    strokeWidth: 0,
    fill: "b4b4b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hor",
    width: 24,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ver",
    width: 6,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "3d1",
    points: "0,0 24,0 0,24",
    strokeWidth: 0,
    fill: "b4b4b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "3d2",
    points: "0,24 24,0 24,24",
    strokeWidth: 0,
    fill: "#dadada"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b4b4b4"
  }, /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 48,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 72,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 96,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 120,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 144,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 168,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 192,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 216,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 216,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 216,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 216,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 216,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 240,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 264,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 288,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 312,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 336,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 360,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 384,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 408,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 432,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 456,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 480,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 504,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 528,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 552,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 576,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 240,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 264,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 336,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 432,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 600,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 48,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 72,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 120,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 144,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 168,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 192,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 288,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 408,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 504,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600,
    y: 624,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624,
    y: 624,
    xlinkHref: "#p"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderQr);
export default __webpack_public_path__ + "static/media/placeholder-qr.8163313dc0e20b828f16d3bc5fe130fa.svg";
export { ForwardRef as ReactComponent };